/**
 * Resolve the value of a CSS variable defined in :root.
 *
 * Example: resolveCssVariable('--color-xyz') returns '#my-hex-value'
 *
 * Example: resolveCssVariable('unknown') returns '' and logs a warning
 * @param variableName the name of the CSS variable, including the '--' prefix
 * @returns the resolved value of the CSS variable, or an empty string if not defined
 */
export const resolveCssVariable = (variableName: string): string => {
  const styles = getComputedStyle(document.documentElement);
  const value = styles.getPropertyValue(variableName).trim();

  // Warn if the variable is not defined, don't throw an error
  if (value === '') {
    console.warn(`CSS variable "${variableName}" is not defined.`);
  }
  return value;
};
